<template>
  <div>
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Import Large Files' }"
      >
      IMPORT LARGE FILES
      </v-tab>
    </v-tabs>
    <router-view />
    <ImportStatus/>
  </div>
</template>

<script>
import ImportStatus from '../../components/import/ImportStatus.vue';

export default {
  name: 'importLargeFiles',
  components: {
    ImportStatus,
  },
};
</script>
